module.exports = __webpack_public_path__ + "img/1800.4c2190cc.jpg";